import { DataSource, DataSourceUID } from "../forms/dataSource";

/**
 * interface generic DataSourceService and DataSourceService use in application
 * @packageDocumentation
 * @module DataSourceService
 */
export const DATA_SOURCE_SERVICE = "DataSourceService";

/**
 * DataSourceService interface 
 */
export interface DataSourceService {

    /** Get a dataSource from DataSourceUID */
    getDataSource<T = unknown, V = string | number | null, DataSourceContext = unknown>(uid: DataSourceUID): DataSource<T, V, DataSourceContext> | undefined;

}
